import styles from "./styles.module.scss";
import Icon from "@src/components/Icon";

function Footer() {
  return (
    <footer
      className={`pt-[4rem] h-[400px] flex flex-col items-center gap-4 bg-[#EBE3CE] text-[#292524]`}
    >
      <div className="text-[#4B4838]">
        <Icon iconName="ring2" />
      </div>

      <p className="uppercase font-calabassas text-xl text-[#4B4838]">
        Made with{" "}
        <span className="underline">
          <a href="https://app.inawo.com/" target="_blank" rel="noreferrer">
            Inawo
          </a>
        </span>
      </p>
      <p className="font-light font-inter text-center max-w-[60vw]">
        The number 1 wedding website maker for the culturally relevant
      </p>
    </footer>
  );
}

export default Footer;
